import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "titleDD" }, "Información general del cliente", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "subTitleDD" }, "Actividad Económica - Principal*", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "subTitleDD" }, "Actividad Económica - Secundaria", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    "label-position": "top",
    "label-width": "auto",
    class: "greenItem"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_el_row, {
        gutter: 24,
        justify: "space-evenly"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Nacionalidad" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.objetoCliente.Nacionalidad,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.objetoCliente.Nacionalidad) = $event)),
                    placeholder: "Seleccionar",
                    filterable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.pais, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.paisid,
                          label: item.nombre,
                          value: item.nombre
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.DeshabilitarCamposJuridicos != 'Jurídica']
          ]),
          _withDirectives(_createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Ocupación" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.objetoCliente.Ocupacion,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.objetoCliente.Ocupacion) = $event)),
                    placeholder: "Seleccionar"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.ocupacion, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.codigo,
                          label: item.valor,
                          value: item.valor
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.DeshabilitarCamposJuridicos != 'Jurídica']
          ]),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Documento de Constitución" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.objetoCliente.DocumentoConstitucion,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.objetoCliente.DocumentoConstitucion) = $event)),
                    placeholder: "Seleccionar"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.documentoDeConstitucion, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.codigo,
                          label: item.valor,
                          value: item.valor
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Número (Si aplica)" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.objetoCliente.Numero,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.objetoCliente.Numero) = $event)),
                    onKeypress: _ctx.func.OnlyNumbers
                  }, null, 8, ["modelValue", "onKeypress"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "País de Constitución*" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.objetoCliente.PaisConstitucion,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.objetoCliente.PaisConstitucion) = $event)),
                    placeholder: "Seleccionar",
                    filterable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.pais, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.paisid,
                          label: item.nombre,
                          value: item.nombre
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionCliente.PaisConstitucion.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Fecha de Constitución*" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    type: "date",
                    placeholder: "Seleccionar",
                    style: {"width":"100%"},
                    modelValue: _ctx.objetoCliente.FechaConstitucion,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.objetoCliente.FechaConstitucion) = $event)),
                    format: "DD/MM/YYYY"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionCliente.FechaConstitucion.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Registro Público (Si aplica)" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.objetoCliente.RegistroPublico,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.objetoCliente.RegistroPublico) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Tipo de Constitución" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.objetoCliente.TipoConstitucion,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.objetoCliente.TipoConstitucion) = $event)),
                    placeholder: "Seleccionar"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.tipoDeConstitucion, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.codigo,
                          label: item.valor,
                          value: item.valor
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createVNode(_component_el_form_item, { label: "Código CIIU" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.objetoCliente.CodigoCIIU1,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.objetoCliente.CodigoCIIU1) = $event)),
                    filterable: "",
                    placeholder: "Seleccione"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.actividadEconomica, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.codigo,
                          label: item.codigo +' - '+ item.valor,
                          value: item.codigo + ' - ' + item.valor
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionCliente.CodigoCIIU1.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createVNode(_component_el_form_item, { label: "Código CIIU" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.objetoCliente.CodigoCIIU2,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.objetoCliente.CodigoCIIU2) = $event)),
                    filterable: "",
                    clearable: "",
                    placeholder: "Seleccione"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.actividadEconomica, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.codigo,
                          label: item.codigo +' - '+ item.valor,
                          value: item.codigo + ' - ' + item.valor
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 8,
            sm: 8,
            md: 8,
            lg: 8,
            xl: 8,
            style: {"padding":"0px 0 0 12px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "¿La empresa es entidad vigilada?*" })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 4,
            sm: 4,
            md: 4,
            lg: 4,
            xl: 4
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.objetoCliente.EntidadVigilada,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.objetoCliente.EntidadVigilada) = $event)),
                placeholder: "Seleccionar",
                class: "selectDD"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.generico, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.codigo,
                      label: item.valor,
                      value: item.valor
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionCliente.EntidadVigilada.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 8,
            sm: 8,
            md: 8,
            lg: 8,
            xl: 8,
            style: {"padding":"0px 0 0 12px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "¿La empresa está obligada a implementar el sistema LAFT o a fines?*" })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 4,
            sm: 4,
            md: 4,
            lg: 4,
            xl: 4
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.objetoCliente.SistemaLAFT,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.objetoCliente.SistemaLAFT) = $event)),
                placeholder: "Seleccionar",
                class: "selectDD"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.generico, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.codigo,
                      label: item.valor,
                      value: item.valor
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionCliente.SistemaLAFT.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "Referencia las normas que aplican y la entidad o entidades de control.",
                style: _normalizeStyle([_ctx.objetoCliente.EntidadVigilada !== 'Si' ? { opacity: '0.15' } : {}])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    disabled: _ctx.objetoCliente.EntidadVigilada !='Si',
                    modelValue: _ctx.objetoCliente.EntidadControl,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.objetoCliente.EntidadControl) = $event))
                  }, null, 8, ["disabled", "modelValue"])
                ]),
                _: 1
              }, 8, ["style"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionCliente.EntidadControl.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "Referencia la fecha de inicio de implementación en la entidad. ",
                style: _normalizeStyle([_ctx.objetoCliente.SistemaLAFT !== 'Si' ? { opacity: '0.15' } : {}])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    type: "date",
                    placeholder: "Seleccionar",
                    style: {"width":"100%"},
                    disabled: _ctx.objetoCliente.SistemaLAFT !='Si',
                    modelValue: _ctx.objetoCliente.FechaImplementacion,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.objetoCliente.FechaImplementacion) = $event)),
                    format: "DD/MM/YYYY"
                  }, null, 8, ["disabled", "modelValue"])
                ]),
                _: 1
              }, 8, ["style"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionCliente.FechaImplementacion.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 8,
            sm: 8,
            md: 8,
            lg: 8,
            xl: 8,
            style: {"padding":"0px 0 0 12px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Realiza transacciones, custodia o manejo de activos virtuales *" })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 4,
            sm: 4,
            md: 4,
            lg: 4,
            xl: 4
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.objetoCliente.ActivosVirtuales,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.objetoCliente.ActivosVirtuales) = $event)),
                placeholder: "Seleccionar",
                class: "selectDD"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.generico, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.codigo,
                      label: item.valor,
                      value: item.valor
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionCliente.ActivosVirtuales.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}